var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TypeaheadDynamic',{attrs:{"placeholder":"Search Projects","get-items":_vm.getItems,"value-field":_vm.textField,"text-field":_vm.textField,"input-class":"input-underline"},on:{"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }